export type SegmentEntity = "companies" | "contacts";
export type SegmentCondition = { field: string; op: string; value?: unknown };
export type SegmentGroup = { all: SegmentNode[] } | { any: SegmentNode[] };
export type SegmentNode = SegmentGroup | SegmentCondition;
export type SegmentFilter = SegmentGroup | Record<string, never>;
export type SkipReason =
  | "no_email"
  | "suppressed"
  | "do_not_call"
  | "no_consent";
export const SKIP_REASONS: readonly SkipReason[] = Object.freeze([
  "no_email",
  "suppressed",
  "do_not_call",
  "no_consent",
]);

export const isGroup = (n: unknown): n is SegmentGroup =>
  typeof n === "object" &&
  n !== null &&
  !Array.isArray(n) &&
  ("all" in n || "any" in n);
export const groupChildren = (g: SegmentGroup): SegmentNode[] =>
  "all" in g ? g.all : g.any;
export const isEmptyFilter = (f: unknown): boolean =>
  typeof f === "object" &&
  f !== null &&
  !Array.isArray(f) &&
  Object.keys(f).length === 0;
